import { render, staticRenderFns } from "./SendRestaurantDetails.vue?vue&type=template&id=f692bdfa&scoped=true"
import script from "./SendRestaurantDetails.vue?vue&type=script&lang=js"
export * from "./SendRestaurantDetails.vue?vue&type=script&lang=js"
import style0 from "./SendRestaurantDetails.vue?vue&type=style&index=0&id=f692bdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f692bdfa",
  null
  
)

export default component.exports